import React, { useEffect, useState } from 'react';
import './Courses.css';
import caro1 from './Images/cor1.jpg';
import cor2 from  './Images/cor2.jpg';
import cor3 from  './Images/cor3.jpg';
import cor4 from  './Images/cor4.jpg';
import cor5 from  './Images/cor5.png';
import cor6 from  './Images/cor6.png'
// import zodiacwheel from './Images/Zodiac-wheel.png';
function Testimonials() {
  const [showModal, setShowModal] = useState(false);
const [selectedCourse, setSelectedCourse] = useState(null);
 
  const [headingIdx, setHeadingIdx] = useState(0);
  const [blink, setBlink] = useState(true);

  // useEffect(() => {
  //   // Blink for 1.2s, then swap text after 2s
  //   const blinkTimeout = setTimeout(() => setBlink(false), 1200);
  //   const swapTimeout = setTimeout(() => {
  //     setHeadingIdx((idx) => (idx + 1) % headings.length);
  //     setBlink(true);
  //   }, 2000);
  //   return () => {
  //     clearTimeout(blinkTimeout);
  //     clearTimeout(swapTimeout);
  //   };
  // }, [headingIdx, blink]);

// -- Testimonials data & carousel state ---------------------------------
const testimonialsList = [
  { id: 1, name: 'Yuvaraj K', rating: 5, text: `'I'm so happy to share this! The method of teaching "NADI ASTROLOGY" is excellent – it's easy to understand, with perfect live examples. Understanding the nature of planets is made simple and easy to remember. As you said, Once you start to love astrology. People, incidents, and everything you see with கிரக காரகம்.' You're great, sir; I feel truly blessed to be on this journey with you. My gratitude goes out to both you and the universe for the chance to embark on this journey with you`, link: 'https://share.google/wNEFl5lmh6P4pFrsU' },
  { id: 2, name: 'Revathy', rating: 5, text: `Learning under your guidance has been a truly enriching experience. Your teaching style reflects the dedication and wisdom of the great mentors we remember from our childhood.
Thank you for creating such a positive and inspiring learning environment. I'm truly grateful for the opportunity and look forward to continuing this journey with the same passion and purpose.`, link: 'https://share.google/PQpkrfygympyUWxuj' },
  { id: 3, name: 'Sargunan K', rating: 5, text: `Have attend many classes and many methods/systems of astrology, but what he taught is very simple and easily understandable.
Mainly we can accurately make the predictions, which gives confidence as an astrologer. Realy very good...!👍🏻`, link: 'https://share.google/5fPVlWFRZAex1HnPh' },
  { id: 4, name: 'Parvathi Mohan', rating: 5, text: `This is my first time attending your class. The way you explain the concepts very clearly is very good. I have never heard anything like this anywhere. The way you conduct yourself is very easy for me to understand. Thank you very much. I thank the universe for giving me the opportunity to attend your class`, link: 'https://share.google/zIKpNtGDoC8wMMrzb' },
  { id: 5, name: 'Navalar astro', rating: 5, text: `Salute to Brahmasree Acharya Thiru Senthilkumar, who taught the clients who come to Nadi Astrology to know only the date of birth without knowing the time of birth, how to interpret the current horoscope and get the results in a very simple way. Bhaskara Astrologer Kalaratna Novelar`, link: 'https://share.google/bmUNVVnaZnwQrH1UJ' },
  { id: 6, name: 'Sharmila Devi', rating: 5, text: `
The Nadi class you are conducting for us is very wonderful. You are making us mature by teaching us your experiences and mantras and meditations to help us rise in life. I am indebted to the universe for making you our guru. Thank you, thank you, thank you. `, link: 'https://share.google/Rb7UM1fI1KcHA8dQt' },
  { id: 7, name: 'Venkateshwari Palanichamy', rating: 5, text: `The Bhrigu Nandi Nadi class conducted by our teacher Sir is very wonderful and excellent. Every day, the lessons he conducts are fresh and vibrant. In my humble opinion, Sir, he is unmatched in teaching by giving examples. Sir, I sincerely thank the universe and God for giving me the opportunity to attend your class.`, link: 'https://share.google/FIWKigT3bBbhd2hLl' },
  { id: 8, name: 'Siva Kumar', rating: 5, text: `Hello... I am studying Bhrigunandhi Nadi and Saptarishi Nadi astrology through Mr. Senthil Acharya. His classes are excellent... I have got the opportunity to study astrology with clear explanations. Thank you very much to the teacher Mr. Senthil Acharya🙏🙏🙏🙏`, link: 'https://share.google/KbCmIfWk1R3QxsmjN' },
  { id: 9, name: 'M. Karthika', rating: 5, text: `Thank you very much sir for explaining with your example. You explained very clearly in the last class what kind of benefits are there in astrology from the perspective of planets and their artificiality. Thank you very much sir.`, link: 'https://share.google/lNBbglAnvge36CJC2' },
  { id: 10, name: 'Annalakshmi G', rating: 5, text: `Your class is very good and easy to understand.. There is no need to memorize anything with difficulty.. The class is in a conversational manner.. You have changed the illusion that astrology is not very difficult to understand.. The way you explained all the planetary characteristics with practical life will never be forgotten.. Many thanks..`, link: 'https://share.google/ZaIgNMleTyHCjT4kU' }
];

const [testiIdx, setTestiIdx] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setTestiIdx((i) => (i + 1) % testimonialsList.length);
  }, 5000);
  return () => clearInterval(interval);
}, []);
  return (
    <div  className="testimonials-page " style={{ height: 'auto', color:'white', padding: '20px' }}>
      <h1 className='section-heading'>Our Testimonials</h1>
        {/* <img src={zodiacwheel} alt="zodiac-wheel" className="zodiac-wheel" ></img> */}
<section className="testimonials-section">
        <div className="testimonials-grid">
          {(() => {
            const visibleCount = 5;
            const visible = Array.from({ length: visibleCount }).map((_, k) => testimonialsList[(testiIdx + k) % testimonialsList.length]);
            return visible.map((t) => (
              <a key={t.id} href={t.link} target="_blank" rel="noreferrer noopener">
                <div className="testimonial-card">
                  <div className="testimonial-card-title">
                    <div>{t.name}</div>
                    <div className="testimonial-stars">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <span key={i}>★</span>
                      ))}
                      {Array.from({ length: 5 - t.rating }).map((_, i) => (
                        <span key={i} className="empty-star">★</span>
                      ))}
                    </div>
                  </div>
                  <p className="testimonial-text">{t.text}</p>
                </div>
              </a>
            ));
          })()}
        </div>
        <div className="testimonial-dots">
          {testimonialsList.map((_, i) => (
            <span key={i} onClick={() => setTestiIdx(i)} className={`testimonial-dot${testiIdx === i ? ' active' : ''}`} />
          ))}
        </div>
      </section>
      
    </div>
  );
}

export default Testimonials;
